import { AreaConstants } from './area.constants';
import { PermissionConstants } from './permission.constants';

export class GroupConstants {
    static readonly Group1 = {
        titlePage: 'Operational Permissions',
        titleTab: 'Operational',

        areas: [
            AreaConstants.Ageing,
            AreaConstants.Annexure,
            AreaConstants.ClaimData,
            AreaConstants.Performance,
            AreaConstants.PremiumData,
            AreaConstants.Sales
        ] as string[],

        permissions: [
            PermissionConstants.Full,
            PermissionConstants.View,
            PermissionConstants.Import,
            PermissionConstants.Export,
            PermissionConstants.DeleteCompleted,
            PermissionConstants.DeletePending
        ] as string[]
    };

    static readonly Group2 = {
        titlePage: 'Matching Permissions',
        titleTab: 'Matching',

        areas: [
            AreaConstants.Matching,
        ] as string[],

        permissions: [
            PermissionConstants.Full,
            PermissionConstants.View,
            PermissionConstants.Matching,
            PermissionConstants.Export,
            PermissionConstants.DeleteCompleted,
            PermissionConstants.DeletePending
        ] as string[]
    };

    static readonly Group3 = {
        titlePage: 'Administrative Permissions',
        titleTab: 'Administrative',

        areas: [
            AreaConstants.Client,
            AreaConstants.ClientArea,
            AreaConstants.Endorsement,
            AreaConstants.ExchangeRate,
            AreaConstants.PolicyGroup,
            AreaConstants.Tenant,
            AreaConstants.User,
            AreaConstants.Role,
            AreaConstants.PopiData
        ] as string[],

        permissions: [
            PermissionConstants.Full,
            PermissionConstants.View,
            PermissionConstants.Create,
            PermissionConstants.Edit,
            PermissionConstants.Export,
            PermissionConstants.Delete
        ] as string[]
    };

    static readonly Group4 = {
        titlePage: 'Reporting Permissions',
        titleTab: 'Reporting',

        areas: [
            AreaConstants.DeclarationReports,
            AreaConstants.RenewalReports,
            AreaConstants.AdminReports,
            AreaConstants.AuditLog
        ] as string[],

        permissions: [
            PermissionConstants.View,
        ] as string[]
    };
}
